import { render, staticRenderFns } from "./MakePaymentOrder.vue?vue&type=template&id=72f5c82a&"
import script from "./MakePaymentOrder.vue?vue&type=script&lang=js&"
export * from "./MakePaymentOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports